import { render, staticRenderFns } from "./TemplateDesign.vue?vue&type=template&id=319f9b81&scoped=true"
import script from "./TemplateDesign.vue?vue&type=script&lang=js"
export * from "./TemplateDesign.vue?vue&type=script&lang=js"
import style0 from "./TemplateDesign.vue?vue&type=style&index=0&id=319f9b81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319f9b81",
  null
  
)

export default component.exports